import { useBroadcast } from "@/utilities/broadcast";
import { debounce } from "@/vue/helpers";
import axios from "axios";

const { postMessage } = useBroadcast('user_activity');
export const refreshToken = debounce(async () => {
    await axios.get('/csrf-token');
    postMessage({ type: 'stay' });
}, 2000);
